import { Component, Input, OnInit } from "@angular/core";
import { UpgradePricingInterface } from "@features/subscriptions/interfaces/upgrade-pricing.interface";
import { UpgradeResponseInterface } from "@features/subscriptions/interfaces/upgrade-response.interface";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

@Component({
  selector: "astrobin-upgrade-pricing-modal",
  templateUrl: "./upgrade-pricing-modal.component.html",
  styleUrls: ["./upgrade-pricing-modal.component.scss"]
})
export class UpgradePricingModalComponent implements OnInit {
  @Input() upgradePricing: UpgradePricingInterface;
  @Input() onUpgrade: () => Observable<UpgradeResponseInterface>;

  loading = false;
  errorMessage: string = null;

  constructor(
    public readonly activeModal: NgbActiveModal,
    public readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {}

  confirmUpgrade(): void {
    this.loading = true;
    this.errorMessage = null;

    this.onUpgrade().subscribe({
      next: (response: UpgradeResponseInterface) => {
        this.loading = false;
        if (response.success) {
          this.activeModal.close(response);
        } else {
          this.errorMessage = response.error || this.translateService.instant("Upgrade failed. Please try again.");
        }
      },
      error: error => {
        this.loading = false;

        let errorMessage = this.translateService.instant("Upgrade failed. Please try again.");
        if (error && typeof error === "string") {
          errorMessage = error;
        } else if (error?.error?.message) {
          errorMessage = error.error.message;
        } else if (error?.message) {
          errorMessage = error.message;
        }

        this.errorMessage = errorMessage;
      }
    });
  }

  cancel(): void {
    this.activeModal.dismiss(false);
  }
}
